interface StatusClassOptions {
  size?: 'xs' | 'sm' | 'base'
}

const getSizeClasses = (size: StatusClassOptions['size'] = 'xs') => {
  switch (size) {
    case 'sm':
      return 'text-sm'
    case 'base':
      return 'text-base'
    default:
      return 'text-xs'
  }
}

export const getProgramStatusClass = (status: string, options: StatusClassOptions = {}) => {
  const { size } = options
  const baseClasses = `px-2 py-1 rounded-full ${getSizeClasses(size)} inline-flex items-center justify-center whitespace-nowrap`

  if (status.includes('current') && status.includes('applying')) {
    return `${baseClasses} bg-blue-50 text-blue-700`
  }
  if (status.includes('current')) {
    return `${baseClasses} bg-green-50 text-green-700`
  }
  if (status.includes('graduated') && status.includes('qualifying')) {
    return `${baseClasses} bg-purple-50 text-purple-700`
  }
  if (status.includes('graduated')) {
    return `${baseClasses} bg-indigo-50 text-indigo-700`
  }
  if (status.includes('expelled') || status.includes('quit') || status.includes('disappeared')) {
    return `${baseClasses} bg-red-50 text-red-700`
  }
  if (status.includes('paused')) {
    return `${baseClasses} bg-yellow-50 text-yellow-700`
  }
  return `${baseClasses} bg-gray-50 text-gray-700`
}

export const getRelationshipStatusClass = (status: string, options: StatusClassOptions = {}) => {
  const { size } = options
  const baseClasses = `px-2 py-1 rounded-full ${getSizeClasses(size)} inline-flex items-center justify-center whitespace-nowrap`

  if (status.includes('happy') || status.includes('engaged')) {
    return `${baseClasses} bg-green-50 text-green-700`
  }
  if (status.includes('stopped') || status.includes('quit')) {
    return `${baseClasses} bg-red-50 text-red-700`
  }
  if (status.includes('current')) {
    return `${baseClasses} bg-blue-50 text-blue-700`
  }
  if (status.includes('graduated')) {
    return `${baseClasses} bg-purple-50 text-purple-700`
  }
  if (status.includes('distant') || status.includes('quieted')) {
    return `${baseClasses} bg-yellow-50 text-yellow-700`
  }
  return `${baseClasses} bg-gray-50 text-gray-700`
}

export const getExpeditionStatusClass = (status: string, options: StatusClassOptions = {}) => {
  const { size } = options
  const baseClasses = `px-2 py-1 rounded-full ${getSizeClasses(size)} inline-flex items-center justify-center whitespace-nowrap`
  return `${baseClasses} bg-cosmicPurple/10 text-cosmicPurple`
}

export const getContractTypeStatusClass = (status: string, options: StatusClassOptions = {}) => {
  const { size } = options
  const baseClasses = `px-2 py-1 rounded-full ${getSizeClasses(size)} inline-flex items-center justify-center whitespace-nowrap`
  return `${baseClasses} bg-lime-50 text-lime-700`
} 